import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ShopCart from "./shopCart";

function Nav({ furniture, scrollToComponent, scrollToComponentChair }) {
  const location = useLocation();
  const { itemInCart } = useSelector((state) => state.cart);
  const [cart, setCart] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // явно отслеживаем состояние
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const contactButtonRef = useRef(null);
  const modalRef = useRef(null);

  // Закрытие модалки контактов
  const handleModalOpen = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
    const rect = contactButtonRef.current.getBoundingClientRect();
    setModalPosition({
      top: rect.bottom + window.pageYOffset + 8,
      left: rect.left + window.pageXOffset,
    });
  };

  const handleModalClose = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      window.addEventListener("click", handleModalClose);
      window.addEventListener("scroll", () => setIsModalOpen(false));
    }
    return () => {
      window.removeEventListener("click", handleModalClose);
      window.removeEventListener("scroll", () => setIsModalOpen(false));
    };
  }, [isModalOpen]);

  // Корзина
  const handleCartClick = () => {
    if (itemInCart.length === 0) {
      toast.info("Себет бош. Себетке буюмдарды кошуңуз.");
    } else {
      setCart(true);
      if (window.fbq) {
        window.fbq("track", "InitiateCheckout", {
          content_ids: itemInCart.map((item) => item.id),
          content_type: "product",
          num_items: itemInCart.length,
          value: itemInCart.reduce((total, item) => total + item.price, 0),
          currency: "KGS",
        });
      }
    }
  };

  // Закрываем мобильное меню при смене страницы
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav className="fixed px-4 lg:px-8 -mb-20 mt-2 max-[440px]:-mt-4 left-2 right-2 rounded-full max-w-[1200px] mx-auto">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {/* Основная строка с логотипом и бургером */}
      <div className="flex justify-between items-center py-4 bg-white shadow-md px-6 rounded-3xl">
        {/* Логотип */}
        <div className="flex items-center">
          <div className="logo md:border-r-2 pr-4">
            <Link to="/" className="flex items-center space-x-3">
              <h1 className="text-2xl font-bold text-gray-900">AJAR</h1>
              <p className="text-sm text-gray-600">MEBEL</p>
            </Link>

            {/* Десктопное меню (остаётся как было) */}
          </div>
          <ul className="hidden md:flex justify-start items-center gap-x-6 pl-4 py-6 text-sm font-medium text-gray-800">
            <li>
              <Link to="/about">Биз жөнүндө</Link>
            </li>
            <li className="cursor-pointer">
              <p onClick={scrollToComponent}>Столдор</p>
            </li>
            <li className="cursor-pointer">
              <p onClick={scrollToComponentChair}>Стулдар</p>
            </li>
            <li>
              <Link to="/deliveryInfo">Жеткирүү жана чогултуу</Link>
            </li>
          </ul>
        </div>
        <div className="hidden md:flex">
          {" "}
          {/* Кнопка Контакты */}
          <button
            ref={contactButtonRef}
            className="px-6 py-3 bg-[#A1C349] hover:bg-[#beda76] text-white font-semibold rounded-full shadow-lg transition transform hover:scale-105"
          >
            <a
              href="https://wa.me/+996707178620"
              target="_blank"
              rel="noopener noreferrer"
            >
              Бизге байланышыңыз
            </a>
          </button>
        </div>

        {/* Бургер-кнопка (только на мобильных) */}
        <div className="md:hidden">
          <input
            id="menu-toggle"
            type="checkbox"
            className="hidden"
            checked={isMobileMenuOpen}
            onChange={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          />
          <label
            htmlFor="menu-toggle"
            className="menu-button-container cursor-pointer block"
          >
            <div className="menu-button"></div>
          </label>
        </div>
      </div>

      {/* Мобильное меню — появляется ТОЛЬКО когда открыто */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 mt-4 z-50 px-4">
          <ul className="bg-white rounded-3xl shadow-xl px-6 py-6 space-y-5 text-start">
            <li className="font-medium text-lg">
              <Link to="/about" onClick={() => setIsMobileMenuOpen(false)}>
                Биз жөнүндө
              </Link>
            </li>
            <li className="font-medium text-lg cursor-pointer">
              <p
                onClick={() => {
                  scrollToComponent();
                  setIsMobileMenuOpen(false);
                }}
              >
                Столдор
              </p>
            </li>
            <li className="font-medium text-lg cursor-pointer">
              <p
                onClick={() => {
                  scrollToComponentChair();
                  setIsMobileMenuOpen(false);
                }}
              >
                Стулдар
              </p>
            </li>
            <li className="font-medium text-lg">
              <Link
                to="/deliveryInfo"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Жеткирүү жана чогултуу
              </Link>
            </li>

            {/* Иконки контактов в строку */}
            <li className="border-gray-200">
              <div className="flex justify-start items-center gap-x-6 flex-wrap">
                <div className="flex items-center space-x-3">
                  <a href="tel:+996707178620">
                    <ion-icon
                      name="logo-whatsapp"
                      size="large"
                      className="text-gray-600"
                    ></ion-icon>
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <a
                    href="https://www.instagram.com/ajarmebel.kg/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ion-icon
                      name="logo-instagram"
                      size="large"
                      className="text-gray-600"
                    ></ion-icon>
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <a
                    href="https://www.facebook.com/profile.php?id=61568380180272"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ion-icon
                      name="logo-facebook"
                      size="large"
                      className="text-gray-600"
                    ></ion-icon>
                  </a>
                </div>
              </div>
            </li>

            {/* Кнопка Контакты */}
            <li>
              <button
                ref={contactButtonRef}
                className="px-6 py-4 bg-[#A1C349] hover:bg-[#beda76] text-white font-semibold rounded-full shadow-lg transition transform hover:scale-105"
              >
                <a
                  href="https://wa.me/+996707178620"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Бизге байланышыңыз
                </a>
              </button>
            </li>
          </ul>
        </div>
      )}
      {/* Кнопка корзины */}
      <button
        onClick={handleCartClick}
        className="fixed bottom-6 right-6 z-50 bg-[#A1C349] hover:bg-[#9ab556] text-white rounded-full shadow-2xl px-4 pt-4 pb-2 transition"
      >
        <ion-icon name="cart-outline" size="large"></ion-icon>
        {itemInCart.length > 0 && (
          <span className="absolute -top-2 -right-2 bg-white text-[#A1C349] font-bold rounded-full w-7 h-7 flex items-center justify-center text-sm">
            {itemInCart.length}
          </span>
        )}
      </button>

      {cart && <ShopCart furniture={furniture} setCart={setCart} />}
    </nav>
  );
}

export default Nav;
